(function () {
  const { addPerVarPoint } = window.RB.CardLib;

  const oneOnOne = function () {
    return {
      k: "and",
      conds: [
        { k: "count", spec: { type: "unit", friendly: true, here: true }, n: 1, cmp: "exactly" },
        { k: "count", spec: { type: "unit", enemy: true, here: true }, n: 1, cmp: "exactly" },
      ],
    };
  };

  const rainbowToEnergy = [{ op: "payAny", res: "power", varKey: "anomaly", prompt: "Pay how much Power?" }]
    .concat(addPerVarPoint("anomaly", 30, { energy: 1 }));

  const ENEMIES_HERE = function (n) {
    return {
      name: "assault", value: n,
      cond: { k: "count", spec: { type: "unit", enemy: true, here: true }, n: n, cmp: "exactly" },
    };
  };

  window.RB.CardLib = window.RB.CardLib || {};
  window.RB.CardLib.sfd = { oneOnOne: oneOnOne, rainbowToEnergy: rainbowToEnergy, ENEMIES_HERE: ENEMIES_HERE };
})();
